import React, { useContext } from 'react';

import { ModalManagerContext } from '../../ModalsManager';
import PaginationContainer from './PaginationContainer';
import useFetch from '../../../utils/useFetch';


const url = (placementId) => `${process.env.REACT_APP_API_URL}/analytics/marketing/${placementId}`;

const Marketing = ({ state }) => {
  const openModal = useContext(ModalManagerContext);
  const { render } = useFetch(url(state.placementSelected), openModal);

  return render(data => (
    <PaginationContainer data={data} />
  ));
};


export default Marketing;
